export default __webpack_public_path__ + "static/media/physics.1a9e2cd7.gif";